import React from 'react'

class HeaderContentComponent extends React.Component {
  render () {
    return (
      <div style={styles.content}>
        <span style={styles.title}>{this.props.title}</span>
      </div>
    )
  }
}

const styles = {
  content: {
    height: '100px',
    marginTop: '5px'
  },
  title: {
    float: 'left',
    marginTop: '3px',
    marginLeft: '14px',
    fontSize: '32px',
    color: '#FFFFFF',
    fontWeight: 321,
    fontStyle: 'normal'
  }
}

export default HeaderContentComponent
